<!-- nvthinh 12.06.2025: Component video thu nhỏ góc phải dưới -->
<template>
  <div
    v-if="videoPlayerStore.isMinimizedVisible"
    class="minimized-video-player d-flex flex-column"
    :style="videoPlayerStyle"
  >
    <div class="control-wrapper d-flex align-items-center">
      <div class="controls d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-2 title-minimized" @click="handleMaximize">
          <img src="@/assets/images/icons/ic_maximize.svg " alt="Phóng to" class="mr-1" />
          <span>Phóng to</span>
        </div>
        <div class="separator"></div>
        <div class="close-btn" @click="handleClose">×</div>
      </div>
    </div>
    <iframe :src="videoPlayerStore.videoLink" frameborder="0" />
  </div>
</template>

<script setup>
// nvthinh 12.06.2025: Sử dụng store để quản lý state độc lập
import popupUtil from '@/commons/popupUtil';
import {useVideoPlayerStore} from '@/stores/utilities/videoPlayerStore';
import {computed, onMounted, onUnmounted, ref} from 'vue';

const videoPlayerStore = useVideoPlayerStore();

const hasSiblingGettingStartedMini = ref(false);

const videoPlayerStyle = computed(() => ({
  bottom: hasSiblingGettingStartedMini.value ? '60px' : '16px',
}));

const checkSiblingGettingStartedMini = () => {
  const minimizedVideoPlayer = document.querySelector('.minimized-video-player');
  if (minimizedVideoPlayer) {
    const parent = minimizedVideoPlayer.parentElement;
    if (parent) {
      const siblingGettingStartedMini = parent.querySelector('.ms-getting-started-mini');
      if (siblingGettingStartedMini) {
        // Kiểm tra cả sự tồn tại và trạng thái hiển thị
        const style = window.getComputedStyle(siblingGettingStartedMini);
        const isVisible = style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
        hasSiblingGettingStartedMini.value = isVisible;
      } else {
        hasSiblingGettingStartedMini.value = false;
      }
    } else {
      hasSiblingGettingStartedMini.value = false;
    }
  } else {
    hasSiblingGettingStartedMini.value = false;
  }
};

let observer = null;

onMounted(() => {
  checkSiblingGettingStartedMini();

  observer = new MutationObserver(() => {
    checkSiblingGettingStartedMini();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

// nvthinh 12.06.2025: Xử lý phóng to
function handleMaximize() {
  videoPlayerStore.maximize();
  //mở popup video phóng to
  popupUtil.show('IntroductionVideoPopup', {
    data: videoPlayerStore.dataParam,
  });
}

// nvthinh 12.06.2025: Xử lý đóng
function handleClose() {
  videoPlayerStore.hideMinimized();
}
</script>

<style lang="scss" scoped>
/* nvthinh 12.06.2025: Style video thu nhỏ */
.minimized-video-player {
  position: fixed;
  right: 16px;
  width: 320px;
  height: 200px;
  border-radius: 8px;
  z-index: 9999;
  background-color: transparent;
  /* bottom sẽ được set bằng JavaScript */
}
.minimized-video-player iframe {
  width: 100%;
  height: 100%;
  border-radius: 8px 0 8px 8px;
}

.control-wrapper {
  justify-content: flex-end;

  .controls {
    background-color: #7f7f7f;
    padding: 8px 12px;
    border-radius: 8px 8px 0 0;
    cursor: pointer;
    color: #fff;
    gap: 8px;
  }
}

.controls img {
  width: 16px;
  height: 16px;
}
.separator {
  width: 1px;
  height: 16px;
  background-color: #e0e0e0;
}
.close-btn {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  padding: 0 4px;
}
.close-btn:hover {
  opacity: 0.8;
}
.title-minimized {
  margin-top: 2px;
}
</style>
